import { GetTrayUser } from '@/connection/integrations/integrations';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';
import { Channel } from '@/types/channel.types';

const fetchTrayUserReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel }: { channel: Channel }, { rejectWithValue }) => {
      try {
        const instances = await GetTrayUser(channel.channel, channel.name, channel.uuid);
        return instances;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.trayUser = action.payload;
      },
    }
  );
};

export default fetchTrayUserReducer;
